export const ConsumerPostSubmissionApprovedActionTextStyles = {
  container: 'w-full max-w-6xl mb-2 mt-4 px-8 sm:px-16',
  title: 'font-semibold text-24px mb-8',
  description: 'mt-6 mb-2 font-bold text-16px',
  actionText: 'mt-4 text-blue700 text-14px',
}
